// extracted by mini-css-extract-plugin
export var addressFields = "_ii-0";
export var animationContainer = "_ii-1";
export var footer = "_ii-2";
export var lineItems = "_ii-3";
export var modalContent = "_ii-4";
export var orderName = "_ii-5";
export var strong = "_ii-6";
export var warning = "_ii-7";